import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Content } from '../../../components/Content';
import { BookOpen, Columns, Right, Search, Stats, Taxation } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { Modal, ModalControls } from '../../../components/Modal';
import { work } from '../../Api/saga';
import { selectWork } from '../../Api/selectors';
import { hexonReloadAll } from '../../Vehicles/actions';
import { SearchSettings } from '../../Vehicles/components/SearchSettings';
import { generateOptions } from '../actions';
import { GENERATE_OPTIONS } from '../constants';
import {Permission} from "../../../components/Permission";
import {VEHICLE_SEARCH_SETTING_CRUD} from "../../../components/Permission/constants";

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class ToolsOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  render() {
    return (
      <Container>
        <h3>{this.lbl('tools.overview.label')}</h3>
        <Content>
          <div onClick={this.tofn(`/tools/dwh-status`)}>
            <HBox vCenter>
              <Stats />
              <HBox left vCenter>
                {this.lbl('tools.overview.dwh')}
              </HBox>
              <div>
                <Right />
              </div>
            </HBox>
          </div>
          <div onClick={this.tofn(`/tools/bmp-calculator`)}>
            <hr />
            <HBox vCenter>
              <Taxation />
              <HBox left vCenter>
                {this.lbl('tools.overview.bpmLabel')}
              </HBox>
              <div>
                <Right />
              </div>
            </HBox>
          </div>
          <Permission permission={VEHICLE_SEARCH_SETTING_CRUD}>
            <div>
              <hr />
              <HBox>
                <Search />
                <HBox left vCenter>
                  <SearchSettings />
                </HBox>
                <div>
                  <Right />
                </div>
              </HBox>
            </div>
          </Permission>
          <div onClick={this.tofn(`/tools/exact-integration`)}>
            <hr />
            <HBox vCenter>
              <BookOpen />
              <HBox left vCenter>
                {this.lbl('tools.overview.exactLabel')}
              </HBox>
              <div>
                <Right />
              </div>
            </HBox>
          </div>

          <div
            onClick={() => {
              if (confirm('Uitvoeren?')) this.props.generateOptions();
            }}
          >
            <hr />
            <HBox vCenter>
              <Columns />
              <HBox left vCenter>
                {this.props.optionsBusy ? <Loader small /> : null} Generate options
              </HBox>
            </HBox>
          </div>

          <div onClick={this.setStateFn({ confirmHexon: true })}>
            <hr />
            <HBox>Reload all hexon ads</HBox>
            {this.state.confirmHexon ? (
              <Modal onClose={this.setStateFn({ confirmHexon: false })} title={this.lbl(`Reload all hexon ads`)}>
                <ModalControls>
                  <Button
                    onClick={() => {
                      this.props.reloadHexonAds();
                      this.setState({ confirmHexon: false });
                    }}
                    primary
                    disabled={this.disableApplyBtn}
                  >
                    {this.lbl('confirm')}
                  </Button>
                  <Button onClick={this.setStateFn({ confirmHexon: false })}>{this.lbl('cancel')}</Button>
                </ModalControls>
              </Modal>
            ) : null}
          </div>

        </Content>
      </Container>
    );
  }
}



ToolsOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    optionsBusy: selectWork(GENERATE_OPTIONS),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {},
    generateOptions() {
      dispatch(generateOptions());
    },
    reloadHexonAds: () => {
      dispatch(hexonReloadAll());
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ToolsOverview = compose(
  withConnect,
  withRouter,
)(ToolsOverviewComp);
